import { createSlice } from "@reduxjs/toolkit";
import { addOrders, deleteOrders, getOrders, updateOrders } from "./thunk";

export interface OrderItem {
  documentOwner: string;
  idDav: number;
  idProduct: number;
  id: number;
  quantity: number;
  unitPrice: number;
  promotionPrice: number;
  promotionProrated: number;
  observation: string;
  promotionId?: number;
}

export interface Order {
  documentOwner: string;
  id: number;
  sellerId: number;
  customerId: number;
  dateEmission: string;
  status: number;
  amountProducts: number;
  amountPromotion: number;
  observation: string;
  paymentMethodId: number;
  paymentFormId: number;
  items: OrderItem[];

  customerName?: string;
  paymentMethodName?: string;
  paymentFormName?: string;
  sellerName?: string;

  // removido campo de sincronização
  localCreatedAt: string;
}

interface OrdersState {
  orders: Order[];
  errors: Record<string, unknown>;
  error?: string | null;
}

export const initialState: OrdersState = {
  orders: [],
  errors: {},
};

const OrdersSlice = createSlice({
  name: "Orders",
  initialState,
  reducers: {
    // removido reducers de sincronização
  },
  extraReducers: (builder) => {
    builder.addCase(getOrders.fulfilled, (state, action) => {
      const orders = action.payload || [];
      state.orders = orders.map((order: any) => ({
        ...order,
        localCreatedAt: order.localCreatedAt ?? new Date().toISOString(),
      })) as any;
    });
    builder.addCase(getOrders.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
    builder.addCase(addOrders.fulfilled, (state, action) => {
      const newOrder: any = action.payload;
      if (newOrder) {
        const orderWithSync = {
          ...newOrder,
          localCreatedAt: newOrder.localCreatedAt ?? new Date().toISOString(),
        };
        state.orders.unshift(orderWithSync as any);
      }
    });
    builder.addCase(addOrders.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
    builder.addCase(updateOrders.fulfilled, (state, action) => {
      state.orders = state.orders.map((order: Order) => {
        return order.id === action.payload?.id ? { ...order, ...action.payload } : order;
      });
    });
    builder.addCase(updateOrders.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
    builder.addCase(deleteOrders.fulfilled, (state, action) => {
      state.orders = state.orders.filter((order: Order) => {
        return order.id !== action.meta?.arg;
      });
    });
    builder.addCase(deleteOrders.rejected, (state, action) => {
      state.error = action.error.message || null;
    });
  },
});

// removido exportação de reducers de sincronização

export default OrdersSlice.reducer;
